import { createAction, props } from "@ngrx/store";
import { ICapability } from "@skills-app/models/capability";

const prefix = "[Update Capabilities Page]";

export const loadPage = createAction(`${prefix} Load Page`);

export const selectCapability = createAction(
  `${prefix} Select Capability`,
  props<{ capability: ICapability }>(),
);
